import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import * as chanceApi from '../../lib/api/chance';

/**
 * 번호로 상세를 여는 진입점. 기회 번호와 수주품의서 번호를 둘 다 받는다.
 *
 * 상세 화면은 UUID 로 열린다(/chancemng/{uuid}/{단계}/1). 그런데 사람이 주고받는 건
 * 번호다 - 메일이나 메신저에 BI_PJ_2026_09_005 를 붙여 놓고 이야기한다. 그 번호를
 * 그대로 주소에 넣어도 열리게 하려고 둔 자리다.
 *
 * 수주는 따로 열리는 화면이 없다 - 기회의 한 단계다. 그래서 수주 번호로 들어와도
 * 소속 기회로 보낸다. 손에 든 종이에 찍힌 번호가 수주 번호일 때가 많기 때문이다.
 *
 * 여기서는 번호로 UUID 를 받아 바로 상세로 넘긴다. 주소창에 남지 않도록 replace 로 간다 -
 * 뒤로가기를 눌렀을 때 이 화면으로 되돌아와서 다시 튕기면 안 되기 때문이다.
 */
const ChanceByNoPage = ({ kind = 'prj' }) => {
  const params = useParams();
  const no = kind === 'ro' ? params.roNo : params.prjNo;
  const navigate = useNavigate();
  const [error, setError] = useState(null);


  useEffect(() => {
    let active = true;
    const notFoundMessage = kind === 'ro'
      ? '해당 번호의 수주품의서를 찾을 수 없습니다.'
      : '해당 번호의 영업기회를 찾을 수 없습니다.';

    (async () => {
      try {
        const res = kind === 'ro'
          ? await chanceApi.getChanceByRoNo(no)
          : await chanceApi.getChanceByNo(no);
        const info = res.data?.info;
        if (!active) return;
        if (!info?.prjUuid) {
          setError(notFoundMessage);
          return;
        }
        navigate(`/chancemng/${info.prjUuid}/${info.cstGrade || ''}/1`, { replace: true });
      } catch {
        if (active) setError(notFoundMessage);
      }
    })();

    return () => { active = false; };
  }, [no, kind, navigate]);

  if (error) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 10 }}>
        <Typography variant="h6">{error}</Typography>
        <Typography variant="body2" color="text.secondary">
          번호: {no}
        </Typography>
        <Button variant="outlined" onClick={() => navigate('/chancemng', { replace: true })}>
          기회 목록으로
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress />
    </Box>
  );
};

export default ChanceByNoPage;
